const excludedTypes = ["tipper", "yearly"];

export function isContestExcluded(type) {
  return excludedTypes.includes(type);
}
